/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import { getTakeAwayVideo } from '../lib/take-away-video-utils';

const CardVideo = ({
  sessionId,
  setVideoRef,
  onPlay,
  videoUrlPath,
  posterURL,
  videoIsProcessedPosterURL,
  isVideoBeingProcessed,
  playsInline,
}) => {
  const takeAwayVideoURL = getTakeAwayVideo(sessionId, videoUrlPath);

  return (
    <div className="card-video">
      <video
        controls
        ref={setVideoRef}
        poster={isVideoBeingProcessed ? videoIsProcessedPosterURL : posterURL}
        onPlay={onPlay}
        playsInline={playsInline}
      >
        {!isVideoBeingProcessed && <source {...takeAwayVideoURL} />}
      </video>
    </div>
  );
};

CardVideo.propTypes = {
  playsInline: PropTypes.bool,
  sessionId: PropTypes.string.isRequired,
  setVideoRef: PropTypes.func,
  onPlay: PropTypes.func,
  videoUrlPath: PropTypes.string.isRequired,
  posterURL: PropTypes.string,
  videoIsProcessedPosterURL: PropTypes.string,
  isVideoBeingProcessed: PropTypes.bool,
};

CardVideo.defaultProps = {
  setVideoRef: () => {},
  onPlay: undefined,
  playsInline: false,
  posterURL: 'https://images.ctfassets.net/gtqjh9j40j4m/1jcyRXIJWm3Oa74XYFCLO7/b9e88bfe952f89e01782294bacfbef3b/poster.png',
  videoIsProcessedPosterURL: 'https://images.ctfassets.net/gtqjh9j40j4m/5ZRmyBb4b6j9ka9JwZYRHG/0ef1e8d98c078762583c4e46f7c6d9be/video-is-being-processed.png',
  isVideoBeingProcessed: false,
};

export default CardVideo;
